import api from './api';

/**
 * validazioneApi.js — a che punto è la firma dei dieci documenti dei
 * campi clinici.
 *
 * In lettura ci arrivano tutti i ruoli, medici compresi: un medico vede i
 * documenti di cui è responsabile o consultato (lo filtra il server). In scrittura
 * solo amministrazione e segreteria, e il confine lo tengono le rotte —
 * non il fatto che la schermata nasconda i pulsanti.
 */
export const validazioneAPI = {
    elenco: () => api.get('/validazione-campi'),
    medici: () => api.get('/validazione-campi/medici'),

    // I campi assenti non si toccano: mandare solo lo stato non deve
    // cancellare le note.
    aggiorna: (id, dati) => api.put(`/validazione-campi/${id}`, dati),

    aggiungiConsultato: (id, medicoId) =>
        api.post(`/validazione-campi/${id}/consultati`, { medico_id: medicoId }),
    vistoConsultato: (consultatoId, vistoIl) =>
        api.put(`/validazione-campi/consultati/${consultatoId}`, { visto_il: vistoIl }),
    togliConsultato: (consultatoId) =>
        api.delete(`/validazione-campi/consultati/${consultatoId}`),
};

export default validazioneAPI;
